import { FC, memo, useState } from 'react';
// import { Popup } from 'react-map-gl';
import CustomPopup from './CustomPopup';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import { useIntl } from 'react-intl';
import { TRANSLATED_CONSTANTS } from '../../../static/translatedConstants';
import './map.css';

type Props = {
  listings: any;
};

const PopupSlider: FC<Props> = ({ listings }) => {
  const [slideIndex, setSlideIndex] = useState(0);

  const nextSlide = () => {
    setSlideIndex((prevIndex) => (prevIndex === (listings?.length ?? 0) - 1 ? 0 : prevIndex + 1));
  };

  const prevSlide = () => {
    setSlideIndex((prevIndex) => (prevIndex === 0 ? (listings?.length ?? 0) - 1 : prevIndex - 1));
  };

  return (
    <div className="relative popup-shadow">
      <div className="overflow-hidden relative">
        <div
          className="flex transition-transform ease-in-out duration-500 swiper-cards"
          style={{ transform: `translateX(-${slideIndex * 100}%)` }}>
          {listings?.map((listing: any) => (
            <div className="w-[220px] sm:w-[280px] swiper-slide" key={listing.id}>
              <CustomPopup listing={listing} />
            </div>
          ))}
        </div>
      </div>
      {listings?.length > 1 && (
        <>
          <NextArrow nextSlide={nextSlide} />
          <PrevArrow prevSlide={prevSlide} />
        </>
      )}
    </div>
  );
};

// Memoized (map plan A4): popup content only re-renders when its listings
// change, not on every MapboxLe render during pans.
export default memo(PopupSlider);

type NextArrowProps = {
  nextSlide?: any;
};

const NextArrow: FC<NextArrowProps> = ({ nextSlide }) => {
  const intl = useIntl();
  return (
    <button
      type="button"
      aria-label={intl.formatMessage({
        id: TRANSLATED_CONSTANTS.NEXT.id,
        defaultMessage: TRANSLATED_CONSTANTS.NEXT.defaultMessage
      })}
      onClick={nextSlide}
      className="arrows-contaier absolute top-[46%] -right-12 -translate-y-1/2 z-[2] flex h-11 w-11 items-center justify-center rounded-full bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400">
      <ChevronRightIcon className="w-4 h-4" />
    </button>
  );
};

type PrevArrowProps = {
  prevSlide?: any;
};
const PrevArrow: FC<PrevArrowProps> = ({ prevSlide }) => {
  const intl = useIntl();
  return (
    <button
      type="button"
      aria-label={intl.formatMessage({
        id: TRANSLATED_CONSTANTS.PREVIOUS.id,
        defaultMessage: TRANSLATED_CONSTANTS.PREVIOUS.defaultMessage
      })}
      onClick={prevSlide}
      className="arrows-contaier absolute top-[46%] -left-12 -translate-y-1/2 z-[2] flex h-11 w-11 items-center justify-center rounded-full bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400">
      <ChevronLeftIcon className="w-4 h-4" />
    </button>
  );
};
